import { render, staticRenderFns } from "./GoToLogin.vue?vue&type=template&id=2f6a89db&"
import script from "./GoToLogin.vue?vue&type=script&lang=js&"
export * from "./GoToLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports